<template>
    <Dialog class="user-signup-popup semler-dialog" v-if="dictionaryLoaded" @hide="() => {this.$emit('closePopup')}" v-model:visible="showPopup" :dismissableMask="true" :draggable="false" modal :showHeader="false" :pt="{
        root: 'border-none'
    }">
        <template #default="{ closeCallback }">
            <div class="user-signup-popup__wrap">
                <div class="user-signup-popup__image">
                    <img src="/assets/images/userSignupPopupImage.jpg" aria-role="presentation" loading="lazy" />
                </div>
                <div class="user-signup-popup__content">
                    <p class="user-signup-popup__headline">{{ dictionary.userSignupPopupHeadline }}</p>
                    <p class="user-signup-popup__text" v-html="dictionary.userSignupPopupText"></p>
                    <ul class="checked-list">
                        <li v-for="item in sellingPoints" class="checked-list__item"><img
                                src="/assets/images/checkmark_solid_2.svg" width="33" height="33" loading="lazy"
                                role="presentation" />{{ item }}</li>
                    </ul>
                    <div>
                        <Button class="user-signup-popup__create-button p-button-secondary" @click="handleUserCreateClick">{{
        dictionary.userSignupPopupSignupButtonText }}</Button>
                        <Button class="user-signup-popup__create-button p-button-secondary p-button-sm" @click="handleUserCreateClick">{{
        dictionary.userSignupPopupSignupButtonText }}</Button>
                    </div>
                    <Button class="user-signup-popup__close" icon="pi pi-times" severity="secondary" text rounded
                        aria-label="Luk" @click="showPopup = false"></Button>
                </div>
            </div>
        </template>
    </Dialog>
</template>
<script>

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import CustomEventNames from './../../customEventsNames';
const panelToggleSelector = '.member-panel__toggle';

export default {
    name: "userSignupPopup",
    props: ["visible"],
    components: {
        Button,
        Dialog
    },
    data() {
        return {
            dictionary: [],
            dictionaryLoaded: false,
            showPopup: false,
            sellingPoints:[]
        };
    },
    mounted() {
        const vm = this;
        document.addEventListener('click', e => {
            if (e.target.classList.contains('user-signup-popup__login-trigger')) {
                vm.handleUserLoginClick();
            }
        })
    },
    watch: {
        visible: function (newValue, oldValue) {
            this.showPopup = newValue;
        },
        showPopup: {
            handler(newValue, oldValue) {
                const vm = this;
                if (newValue == true && vm.dictionary.length == 0) {
                    fetch('/umbraco/api/resourcesApi/GetUserSignupPopupDictionary').then((response) => response.json())
                        .then((data) => {
                            vm.dictionary = data;
                            vm.sellingPoints = data.userSignupPopupSellingPoints.split('<br />')
                            vm.dictionaryLoaded = true;
                        })
                        .catch((error) => {
                            console.log(error);
                            vm.dictionaryLoaded = true;
                        });
                }
            },
            once: true
        }
    },
    methods: {
        handleUserLoginClick: function () {
            this.showPopup = false;
            this.$emit('closePopup');
            const openUserLoginPanelEvent = new Event(CustomEventNames.openUserLoginPanel);
            document.querySelector(panelToggleSelector).dispatchEvent(openUserLoginPanelEvent);
        },
        handleUserCreateClick: function () {
            this.showPopup = false;
            this.$emit('closePopup');
            const panelToggle = document.querySelector(panelToggleSelector);
            panelToggle.click();
            const openUserCreationPanelEvent = new Event(CustomEventNames.openUserCreationPanel);
            panelToggle.dispatchEvent(openUserCreationPanelEvent);
        }
    }
}
</script>
